// extracted by mini-css-extract-plugin
export default {"controlRow":"orders_page_controlRow__mswt9","controls":"orders_page_controls__a8F2T","modal":"orders_page_modal__JyMHQ","btnContent":"orders_page_btnContent__qgFbn"};